module.exports = __webpack_public_path__ + "img/type-banner-bg.18fbcebd.png";